























import { Component, Prop, Vue } from 'vue-property-decorator';
import SimpleCompanySearch from "@/components/new_style_components/SimpleCompanySearch.vue";
import CompanyDTO from "@/dto/company/CompanyDTO";
import { processError } from "@/utils/ComponentUtils";
import Application from "@/state/Application";
import PRILService from "@/services/request/PRILService";
import SimpleProfileSearch from "@/components/common/SimpleProfileSearch.vue";
import ProfileDTO from "@/dto/profile/ProfileDTO";

@Component({
  components: {
	  SimpleProfileSearch,
    SimpleCompanySearch
  }
})
export default class ChangeCustomerModal extends Vue {
  private selectedProfile: ProfileDTO | null = null;
  private confirmationStep = false;

  @Prop()
  private prilId!: number;

  @Prop()
  private onSuccess!: () => void;

  private closeModal(): void {
    this.resetModal();
    this.$modal.hideAll();
  }

  private resetModal(): void {
    this.selectedProfile = null;
    this.confirmationStep = false;
  }

  private confirmChangeCompany(): void {
    // If we don't have a selected company yet, do nothing
    if (!this.selectedProfile) {
      return;
    }

    // If we're not in confirmation step yet, show confirmation
    if (!this.confirmationStep) {
      this.confirmationStep = true;
      return;
    }

    // If we're in confirmation step and have a selected company, proceed with the API call
    Application.startLoading();
    PRILService.changeCustomer(this.prilId, this.selectedProfile.id!).then(
      resp => {
        Application.stopLoading();
        this.$modal.hideAll();
        this.$bvToast.toast('Company changed successfully', {
          title: 'Success',
          variant: 'success',
          solid: true
        });
        this.onSuccess();
      },
      error => processError(error, this)
    );
  }
}
